module.exports = __webpack_public_path__ + "img/7-2s.fc4fd46e.jpg";